import axios from "@/utils/axios";

// 用户登录
export const clientLogin = async ({ authCode }) => {
  return axios.post("/api/login", {
    authCode: authCode,
  });
};

// 管理员登录
export const adminLogin = async ({ username, password }) => {
  const credentials = btoa(`${username}:${password}`); // Base64 编码
  return axios
    .get("/api/manage/check", {
      headers: {
        Authorization: `Basic ${credentials}`,
      },
      withCredentials: true,
    })
    .then((res) => {
      return { credentials };
    })
    .catch((err) => {
      throw err;
    });
};

// 管理端身份验证
export const adminVerify = async (credentials) => {
  return axios.get("/api/manage/check", {
    headers: {
      Authorization: `Basic ${credentials}`,
    },
    withCredentials: true,
  });
};

// 请求外部链接的文件数据
export const fetchFileFromUrl = async ({ fileUrl }) => {
  return axios.post("/api/fetchRes", { url: fileUrl }, { responseType: "blob" });
};

// 文件上传
export const uploadFile = async ({ uploadParams, formData, onUploadProgress }) => {
  return axios.post(
    "/upload",
    formData, // 请求体
    {
      params: uploadParams, // URL 查询参数
      onUploadProgress: onUploadProgress, // 上传进度回调
      withAuthCode: true,
    }
  );
};

// 清理分块上传的临时数据
export const cleanChunkedUpload = async ({ uploadId, totalChunks }) => {
  return axios.get(`/upload`, {
    params: {
      cleanup: true,
      uploadId: uploadId,
      totalChunks: totalChunks,
    },
    withAuthCode: true,
    timeout: 5000,
  });
};
